import type { GemPack } from '@vm/shared';

/**
 * Gem packs. `priceCents` is USD; the app stores localize. SKUs must match the products created in
 * the Play Console (consumable in-app products) and App Store Connect (consumables).
 */
export const GEM_PACKS: GemPack[] = [
  { id: 'gems_100', name: 'Pouch of Gems', gems: 100, bonus: 0, priceCents: 99, skus: { web: 'gems_100', android: 'vm_gems_100', ios: 'vm.gems.100' } },
  { id: 'gems_550', name: 'Bag of Gems', gems: 500, bonus: 50, priceCents: 499, skus: { web: 'gems_550', android: 'vm_gems_550', ios: 'vm.gems.550' } },
  {
    id: 'gems_1200',
    name: 'Crate of Gems',
    gems: 1000,
    bonus: 200,
    priceCents: 999,
    skus: { web: 'gems_1200', android: 'vm_gems_1200', ios: 'vm.gems.1200' },
    badge: 'Popular',
  },
  { id: 'gems_2500', name: 'Chest of Gems', gems: 2000, bonus: 500, priceCents: 1999, skus: { web: 'gems_2500', android: 'vm_gems_2500', ios: 'vm.gems.2500' } },
  { id: 'gems_6500', name: 'Vault of Gems', gems: 5000, bonus: 1500, priceCents: 4999, skus: { web: 'gems_6500', android: 'vm_gems_6500', ios: 'vm.gems.6500' } },
  {
    id: 'gems_14000',
    name: 'Mountain of Gems',
    gems: 10000,
    bonus: 4000,
    priceCents: 9999,
    skus: { web: 'gems_14000', android: 'vm_gems_14000', ios: 'vm.gems.14000' },
    badge: 'Best value',
  },
];

export const GEM_PACK_BY_ID: Record<string, GemPack> = Object.fromEntries(GEM_PACKS.map((p) => [p.id, p]));

/** Gems credited for a pack (base + bonus). */
export function gemPackTotal(pack: GemPack): number {
  return pack.gems + pack.bonus;
}

/** Finds a pack by a store SKU. */
export function gemPackBySku(platform: 'web' | 'android' | 'ios', sku: string): GemPack | undefined {
  return GEM_PACKS.find((p) => p.skus[platform] === sku);
}
